<template>
  <div>
    <v-data-iterator
        :items="items"
        :items-per-page="itemsPerPage"
        :page.sync="page"
        hide-default-footer
        v-if="items.length > 0"
    >
      <template v-slot:default="props">
        <slot name="content" v-bind="{items: props.items, itemsPerPage, page}"></slot>
      </template>

      <template v-slot:footer>
        <div class="mt-4">
          <v-btn
              small
              color="indigo darken-1"
              dark
              class="mr-1"
              @click="formerPage"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn
              small
              color="indigo darken-1"
              dark
              class="ml-1"
              @click="nextPage"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>

          <span class="ml-4 grey--text">
            Page {{ page }} of {{ numberOfPages }}
          </span>
        </div>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
export default {
  name: "PaginatedList",
  props: {
    items: Array,
    itemsPerPage: Number,
    pageChangeCallback: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.items.length / this.itemsPerPage)
    }
  },
  mounted() {
    this.pageChangeCallback(this.items, this.page, this.itemsPerPage)
  },
  data() {
    return {
      page: 1
    }
  },
  watch: {
    page() {
      console.log("change of page")
      this.pageChangeCallback(this.items, this.page, this.itemsPerPage)
    }
  },
  methods: {
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1
    },
  }
}
</script>

<style scoped>

</style>